Apt.fn.extend('properties', {
	/**
	 * Display a property tooltip
	 *
	 * @param {Object} map
	 * @param {Array} features
	 */
	showTooltip(map, features) {
		const scope = this;
		const $tooltip = $('<div class="preview-tooltip"/>');
		const id = LS.util.pluck(features, 'id');

		if (id.length > 1) {
			$tooltip[0].classList.add('-multiple');

			scope.fetch({
				id: id,
				limit: 12
			}, data => {
				scope.buildTooltip(map, features, $tooltip, data);
			});

			return;
		}

		if (! Apt.panel.opened()) {
			map.highlight();
		}

		LS.api.get('listings/' + id[0] + '/preview', {
			proxy: true,
			success: data => {
				scope.transform(data, 0);

				scope.buildTooltip(map, features, $tooltip, {
					results: [
						data
					]
				});
			}
		});
	},

	/**
	 * Build tooltip
	 *
	 * @param {Object} map
	 * @param {Array} features
	 * @param {$} $tooltip
	 * @param {Object} data
	 */
	buildTooltip(map, features, $tooltip, data) {
		const name = 'tooltip-' + LS.util.uid();
		const app = $.app.make(name, {
			view: 'properties.tooltip',
			target: $tooltip,
			model: data
		});

		let popup = map.showTooltip({
			id: features[0].id,
			center: features[0].geometry.coordinates,
			content: $tooltip[0],
			class: ($.screen.size() < 3 || window.innerHeight <= 480) && ! map.enlarged() ?
				'-preview-mobile' : null,
			onHide: () => {
				$.events.reset('tooltip');

				events.$destroy();
				app.$destroy();

				popup = null;
			}
		});
		let events;

		if (! popup) {
			return;
		}

		data.results.forEach(result => {
			result.images[0].lazy = false;

			LS.analytics.track({
				action: 'preview',
				target: 'listing',
				id: result.id,
				category: 'entry',
				segment: 'tooltip'
			}, {
				key: result.context.key,
				source: result.context.source,
				send: false
			});
		});

		LS.analytics.send();

		const $listings = $$('tooltipListings');

		$$('tooltipLink').on('mousedown', (e, el) => {
			const size = $.screen.size();

			let offset = 125;

			if (size > 4) {
				offset = 307;
			} else if (size > 1) {
				offset = 280;
			}

			$listings.scrollTop(
				offset * $(el).index(), true
			);
		}, {
			namespace: 'tooltip'
		});

		events = Apt.fn['properties.events']()
			.init({
				app: name,
				delegate: $tooltip
			});
	},

	/**
	 * Display cluster information
	 *
	 * @param {Object} map
	 * @param {Array} features
	 */
	showCluster(map, features) {
		const formats = {
			auction: 0,
			lease: 0,
			sale: 0
		};

		let price = 0;
		let size = 0;
		let priceCount = 0;
		let format;
		let missing;
		let prop;

		features.forEach((el, i) => {
			prop = el.properties;

			const group = prop.format || 'sale';

			if (prop.price) {
				priceCount++;
				price += parseFloat(prop.price);
			}

			if (prop.size) {
				size += prop.size;
			} else {
				missing = true;
			}

			formats[group]++;

			if (! i) {
				format = group;
			} else if (group !== format) {
				format = null;
			}
		});

		const message = [];

		if (price && format) {
			message.push(
				`$${LS.util.shortFormat(price / priceCount)} avg ${format} price`
			);
		}

		if (size) {
			message.push(
				LS.util.shortFormat(size, 1) + (missing ? '+' : '') + ' total acres'
			);
		}

		if (! format) {
			for (const [format, count] of Object.entries(formats)) {
				if (count > 0) {
					message.push(count + ' ' + LS.util.plural(format, count));
				}
			}
		}

		map.$private.model.$set('message', message);
	}
}, {
	/**
	 * Load map instance
	 *
	 * @param {Object} [options]
	 */
	loadMap(options) {
		const priv = this.$private;

		if (priv.map) {
			return;
		}

		LS.util.load('maps', () => {
			if (priv.customMap) {
				priv.customMap(options);

				return;
			}

			priv.initMap(options);

			priv.sync = Apt.fn['properties.sync']().init({
				index: priv.index,
				map: priv.map
			});
		});
	},

	/**
	 * Create new map instance
	 *
	 * @param {Object} options
	 */
	initMap(options) {
		const scope = this;
		const pub = scope.$public;
		const bounds = LS.filters.get('bounds');

		options = options || {};

		if (! bounds && ! Apt.maps.parsePosition() && ! $.context('location')) {
			const loc = LS.location.get();

			if (loc) {
				options.center = LS.location.center();

				options.zoom = loc.slug ?
					9 : 6;
			} else {
				const center = scope.index.app.$get('results.0.context.center');

				if (center) {
					options.center = center;
					options.zoom = 9;
				}
			}
		}

		scope.map = Apt.fn.maps().init('$propertiesMap', Object.assign({
			bounds: bounds,
			position: true,
			onClick: (...args) => {
				pub.showTooltip.apply(pub, args);
			},
			onClusterEnter: (...args) => {
				pub.showCluster.apply(pub, args);
			},
			onDraw: coordinates => {
				const position = scope.map.getPosition();
				const filters = {
					bounds: '',
					center: position.center,
					geometry: '',
					limit: '',
					location: '',
					zoom: position.zoom
				};
				const geometry = [];

				if (! coordinates) {
					scope.index.filter(filters);

					return;
				}

				coordinates.forEach(point => {
					point.forEach(value => {
						geometry.push(
							LS.util.round(value, 6)
						);
					});
				});

				filters.geometry = geometry;
				filters.page = 1;

				scope.index.filter(filters);

				if ($.screen.size() < 4) {
					pub.showList();

					document.documentElement.scrollTop = 0;
				}
			}
		}, options));

		if (Apt.panel.opened()) {
			scope.map.pausePosition();
		}

		$$('mapDraw').on('mousedown', () => {
			if (scope.sync.check(true)) {
				scope.sync.disable();
			}
		}, {
			namespace: 'properties'
		});
	},

	/**
	 * Reset map state
	 *
	 * @param {Object} map
	 * @param {Boolean} [reset=false]
	 */
	clearMap(map, reset) {
		const scope = this;

		if (scope.moveend) {
			map.map.off('dragend', scope.moveend);

			scope.moveend = null;
		}

		if (reset) {
			map.highlight();
		}
	}
});